import React from "react";

export default function CookedDogFoodContent() {
  return (
    <div className="flex justify-center items-center min-h-screen py-4">
      <div className="bg-white p-8 shadow-lg rounded-lg w-10/12 md:w-8/12 lg:w-7/12 ">
        <h2 className="text-2xl font-bold mb-4 text-center">
          What is Cooked Dog Food?
        </h2>
        <p className="text-lg mb-4">
          Our cooked dog food is crafted with the same care and attention as a
          home-cooked meal. Made from fresh, human-grade ingredients, our meals
          are gently cooked to preserve essential nutrients and enhance natural
          flavours, ensuring your dog enjoys food that’s both healthy and
          delicious.
        </p>
        <p className="text-lg mb-4">
          With Tucker Tub, you can trust that every meal is made with love,
          using locally sourced ingredients that support a balanced and
          nutritious diet.
        </p>

        <h3 className="text-xl font-semibold mb-4 text-center">
          Benefits of Cooked Dog Food
        </h3>
        <p className="text-lg mb-4">
          If your dog has a sensitive stomach or specific dietary requirements,
          a cooked dog food diet may be ideal. Gently cooked meals are easier to
          digest and retain their natural flavour and nutritional value.
        </p>
        <p className="text-lg mb-4">
          For dogs who prefer softer textures or don’t tolerate raw food well,
          our cooked meals offer a wholesome, tasty alternative that promotes
          overall well-being.
        </p>

        <h3 className="text-xl font-semibold mb-4 text-center">
          Cooked Dog Food Delivery
        </h3>
        <p className="text-lg mb-4">
          Feeding your dog nutritious, freshly prepared meals has never been
          easier. Tucker Tub now delivers cooked dog food with flexible delivery
          schedules to suit your routine.
        </p>
        <p className="text-lg mb-4">
          Whether you choose a one-off order or an ongoing delivery plan, we
          make sure your dog’s meals arrive fresh, ready to serve, and perfectly
          packed to maintain quality.
        </p>

        <h2 className="text-2xl font-bold mb-4 text-center">
          Why Choose Tucker Tub?
        </h2>
        <p className="text-lg mb-4">
          At Tucker Tub, we pride ourselves on using only the best locally
          sourced ingredients to create meals that are both healthy and
          delicious. Our commitment to quality means that each meal is carefully
          cooked and prepared to the highest standard, ensuring your dog
          receives food that supports their health and well-being.
        </p>
        <p className="text-lg mb-4">
          From home-cooked dog food to raw diet options, Tucker Tub offers a
          range of meals tailored to your dog’s needs. With the convenience of
          delivery and the assurance of premium, fresh ingredients, your dog can
          enjoy the best that Tucker Tub has to offer.
        </p>

        <h3 className="text-xl font-semibold mb-4 text-center">
          Fresh Dog Food Delivered in Melbourne & Sydney
        </h3>
        <p className="text-lg mb-4">
          No matter where you are in Melbourne, Victoria, Sydney, or Greater
          Sydney, Tucker Tub ensures your dog’s meals are delivered fresh and on
          time.
        </p>
        <p className="text-lg text-center font-semibold">
          Make the switch to Tucker Tub’s cooked dog food today and give your
          dog the best in taste, nutrition, and convenience.
        </p>
      </div>
    </div>
  );
}
